import { Table, Modal, message, Button, Tag, Space } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useMemo } from "react";
import service from "../../../../@services";
import AuthComponent from "../../../../components/AuthComponent";
export default ({
  dataSource,
  loading,
  editBrand,
  handleTableChange
}) => {
  const disableBrand = async (brandId) => {
    await service.brand.disableBrand(brandId)
    message.success('操作成功');
    handleTableChange()
  };
  const enableBrand = async (brandId) => {
    await service.brand.enableBrand(brandId)
    message.success('操作成功');
    handleTableChange()
  };
  const deleteBrand = async (brandId) => {
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确认要删除吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async ()=>{
        await service.brand.deleteBrand(brandId)
        message.success('操作成功');
        handleTableChange()
      }
    });
  };
  const columns = [
    { title: '序号', dataIndex: '', key: 'index', render: (text,record,index)=> index+1 },
    { title: '品牌编码', dataIndex: 'id', key: 'id' },
    { title: '品牌名称', dataIndex: 'name', key: 'name' },
    { title: '状态', dataIndex: 'status', key: 'status', render: (status)=> (
        status === 1
        ?<Tag color="#87d068">已启用</Tag>
        :<Tag  color="#f50">已禁用</Tag>
      )
    },
    { title: '创建时间', dataIndex: 'createTime', key: 'createTime' },
    {
      title: '操作',
      width: '220px',
      dataIndex: '',
      key: 'x',
      render: (text,record,index) => (
        <Space>
          <AuthComponent authKey="/brand/update">
            <Button onClick={()=>editBrand(record)} type="link">编辑
            </Button>
          </AuthComponent>
          {
            record.status === 1
            ?<AuthComponent authKey="/brand/disable/{brandId}">
              <Button onClick={()=>disableBrand(record.id)} type="link">禁用</Button>
            </AuthComponent>
            :<>
              <AuthComponent authKey="/brand/enable/{brandId}">
                <Button onClick={()=>enableBrand(record.id)} type="link">启用</Button>
              </AuthComponent>
              <AuthComponent authKey="/brand/delete/{brandId}">
                <Button onClick={()=>deleteBrand(record.id)} type="link">删除</Button>
              </AuthComponent>
            </>
          }
        </Space>
      ),
    },
  ];
  const { list, pageIndex, total, pageSize } = useMemo(() => {
    return {
      list: dataSource.result || [],
      pageIndex: dataSource.pageIndex || 1,
      total: dataSource.recordCount || 0,
      pageSize: dataSource.pageSize || 10
    }
  }, [dataSource])
  return (
    <Table
      rowKey={record=>record.code}
      dataSource={list}
      loading={loading}
      pagination={{
        showSizeChanger: true,
        showQuickJumper: true,
        position: ['bottomLeft'],
        current: pageIndex,
        pageSize: pageSize,
        total: total
      }}
      columns={columns}
      onChange={(pagination)=>handleTableChange({
        pageIndex: pagination.current,
        pageSize: pagination.pageSize
      })}
    />
  )
}